export default {
  state: {
    collapseAll: false,
    collapseAllProjects: {
      projects: [],
      toggle: false
    },
    hideCompletedTasks: true,
    hideHoldTasks: true,
    showShortTermTasks: true
  },
  mutations: {
    setcollapseAll(state, value) {
      state.collapseAll = value
    },
    togglecollapseAll(state) {
      state.collapseAll = !state.collapseAll
    },
    togglehideCompletedTasks(state) {
      state.hideCompletedTasks = !state.hideCompletedTasks
    },
    togglehideHoldTasks(state) {
      state.hideHoldTasks = !state.hideHoldTasks
    },
    toggleShowShortTermTasks(state) {
      state.showShortTermTasks = !state.showShortTermTasks
    },
    togglecollapseAllProjects(state, projects) {
      state.collapseAllProjects.toggle = !state.collapseAllProjects.toggle
      state.collapseAllProjects.projects = projects.map(x => ({
        visible: !state.collapseAllProjects.toggle,
        id: x.id
      }))
    },
    toggleSingleProject(state, project) {
      if (!state.collapseAllProjects.projects)
        state.collapseAllProjects.projects.push(project)
      let storedProject = state.collapseAllProjects.projects.find(
        x => x.id == project.id
      )
      if (storedProject) storedProject.visible = project.visible
      else state.collapseAllProjects.projects.push(project)
    }
  },
  actions: {},
  getters: {}
}
